export default function initShowPassword() {
	jQuery('.form-wrap--password').each(function () {
		var holder = jQuery(this);
		var input = holder.find('input');
		var button = holder.find('svg');

		button.on('mousedown', function () {
			input.attr('type', 'text');
		}).on('mouseup', function () {
			input.attr('type', 'password');
		}).on('mouseout', function () {
			input.attr('type', 'password');
		});
	});
}
